<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :model="formData"
        :rules="rules"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="是否自动接单："
              prop="autoAcceptingOrder"
            >
              <el-radio-group
                v-model="formData.autoAcceptingOrder"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in BOOLEAN_STATE"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import { BOOLEAN_STATE } from './constant';

export default {
  components: {
    ListBlock,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BOOLEAN_STATE,
      rules: {
        openPoint: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    validateForm() {
      return this.$refs.formData.validate();
    },
  },
};
</script>
